import { motion } from 'framer-motion';
import { useState } from 'react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  viewport: { once: true, margin: '-100px' },
};

const ProductsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'printers', name: 'Printers' },
    { id: 'photocopiers', name: 'Photocopiers' },
    { id: 'scanners', name: 'Scanners' },
    { id: 'displays', name: 'Interactive Displays' },
  ];

  const products = [
    {
      id: 1,
      name: 'VersaLink C7000',
      category: 'printers',
      specs: 'High-Speed Color Printer',
      image: process.env.PUBLIC_URL + '/images/product_printer.webp',
    },
    {
      id: 2,
      name: 'WorkCentre 7845',
      category: 'photocopiers',
      specs: 'Multifunction Photocopier',
      image: process.env.PUBLIC_URL + '/images/product_copier.webp',
    },
    {
      id: 3,
      name: 'DocuMate 5460',
      category: 'scanners',
      specs: 'Professional Document Scanner',
      image: process.env.PUBLIC_URL + '/images/product_scanner.webp',
    },
    {
      id: 4,
      name: 'Samsung FLIP 2',
      category: 'displays',
      specs: '65" Interactive Display',
      image: process.env.PUBLIC_URL + '/images/product_office.webp',
    },
    {
      id: 5,
      name: 'Phaser 6510',
      category: 'printers',
      specs: 'Color Laser Printer',
      image: process.env.PUBLIC_URL + '/images/product_printer.webp',
    },
    {
      id: 6,
      name: 'AltaLink C8155',
      category: 'photocopiers',
      specs: 'Enterprise Multifunction Device',
      image: process.env.PUBLIC_URL + '/images/product_copier.webp',
    },
  ];

  const filteredProducts =
    selectedCategory === 'all'
      ? products
      : products.filter((p) => p.category === selectedCategory);

  return (
    <div data-testid="products-page" className="pt-32 pb-24 bg-[#F2F0E9]">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <motion.div {...fadeInUp} className="text-center mb-16">
          <h1 className="hero-title text-[#1A1A1A] mb-6 accent-cyan">
            Premium Solutions
          </h1>
          <p className="text-lg md:text-xl text-[#595959] max-w-3xl mx-auto leading-relaxed">
            Curated collection of world-class printing, scanning, and display technology.
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          {...fadeInUp}
          data-testid="category-filter"
          className="flex flex-wrap justify-center gap-4 mb-20"
        >
          {categories.map((cat) => (
            <button
              key={cat.id}
              data-testid={`category-btn-${cat.id}`}
              onClick={() => setSelectedCategory(cat.id)}
              className={`px-6 py-3 text-sm uppercase tracking-widest transition-all duration-500 ${
                selectedCategory === cat.id
                  ? 'bg-[#1A1A1A] text-[#F2F0E9] border border-[#1A1A1A]'
                  : 'bg-transparent text-[#1A1A1A] border border-[#D6D3C9] hover:bg-[#1A1A1A] hover:text-[#F2F0E9]'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </motion.div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {filteredProducts.map((product, index) => (
            <motion.div
              key={product.id}
              data-testid={`product-card-${product.id}`}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="card-hover group"
            >
              <div className="aspect-[4/5] overflow-hidden bg-white mb-6">
                <img
                  loading="lazy"
                  decoding="async"
                  src={product.image}
                  alt={product.name}
                  width="400"
                  height="500"
                  className="w-full h-full object-cover img-desaturate"
                />
              </div>
              <p className="text-xs uppercase tracking-widest text-[#595959] mb-2">
                {product.specs}
              </p>
              <h3 className="serif text-2xl text-[#1A1A1A] mb-4">{product.name}</h3>
              <button
                data-testid={`inquire-btn-${product.id}`}
                className="text-sm uppercase tracking-widest text-[#1A1A1A] hover-underline"
              >
                Inquire Now
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;
